import { router } from 'expo-router';

import { type PaymentMethodSummary } from '../hooks/usePaymentMethod';
import PaymentMethodSection from './PaymentMethodSection';

interface PaymentMethodActionsProps {
    paymentMethod: PaymentMethodSummary | null;
    onPressDelete: () => void;
    onAttached: () => void;
    canDelete?: boolean;
    showCardOwner?: boolean;
}

const PaymentMethodActions = ({
    paymentMethod,
    onPressDelete,
    canDelete = true,
    showCardOwner = false,
}: PaymentMethodActionsProps) => (
    <PaymentMethodSection
        paymentMethod={paymentMethod}
        onPressAdd={() => {
            router.push('/settings/membership/payment-method-add');
        }}
        onPressChange={() => {
            router.push('/settings/membership/payment-method-change');
        }}
        onPressDelete={onPressDelete}
        canDelete={canDelete}
        showCardOwner={showCardOwner}
    />
);

export default PaymentMethodActions;
